const { MinimogThemeStyles, MinimogThemeScripts } = window;
class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false

    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        this.target = target;
        this.toggleLoading(this.target, true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.fetchHtml(productHandle);
      },
    });

    // Optimized delegated handler for card clicks (mobile only)
    document.body.addEventListener('click', (e) => {
      const card = e.target.closest('[data-view="card"]');
      if (!card) return;

      // Only handle on mobile
      if (window.innerWidth >= 767) return;

      // Only trigger if card has 'card-click-popup' class
      if (!card.classList.contains('card-click-popup') && !card.closest('.card-click-popup')) return;

      // Prevent if click is on a quickview button
      if (e.target.closest('.m-product-quickview-button')) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Get product handle and open quickview
      const quickviewBtn = card.querySelector('.m-product-quickview-button');
      if (quickviewBtn?.dataset.productHandle) {
        this.target = quickviewBtn;
        this.toggleLoading(this.target, true);
        this.fetchHtml(quickviewBtn.dataset.productHandle);
      }
    }, true); // Capturing phase

    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) MinimogTheme.ProductQuickView.close()
    });
  }

  fetchHtml(productHandle) {
    loadAssetsNew([MinimogThemeStyles.product, MinimogThemeStyles.productInventory], "quick-view-assets");
    fetchSection("product-quickview", { url: `${window.MinimogSettings.base_url}products/${productHandle}` })
      .then((html) => {
        this.modalContent = html.querySelector(".m-product-quickview");
        const firstModel = html.querySelector("product-model");
        this.mediaGallery = this.modalContent.querySelector("media-gallery");
        loadAssetsNew([MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker, MinimogThemeScripts.productInventory], "variants-picker", () => {
          const colorScheme = this.modalContent.dataset.colorScheme;
          // Clear previous content before appending new one
          if (typeof this.modal.removeChild === 'function') {
            this.modal.removeChild();
          } else if (this.modal.modalContentInner) {
            this.modal.modalContentInner.innerHTML = '';
          }
          this.modal.appendChild(this.modalContent);
          // Hide variant picker if only one option
          hideSingleOptionVariantPicker(this.modal.modal);
          this.modal.setWidth("960px");
          // Add custom class for product quickview modal
          if (this.modal.modal) {
            this.modal.modal.classList.add('product-quickview-modal');
            // Only replace on screens below 767px
            if (window.innerWidth < 767) {
              this.modal.modal.classList.remove('m:items-center');
              this.modal.modal.classList.add('m:items-end');
            } else {
              this.modal.modal.classList.remove('m:items-end');
              this.modal.modal.classList.add('m:items-center');
            }
          }
          this.modal.open();
          document.documentElement.classList.add('prevent-scroll');
          this.modal.setSizes(`m-gradient ${colorScheme}`);
          this.toggleLoading(this.target, false)
          this.isOpen = true
        });
        if (firstModel) {
          loadAssetsNew(
            [
              MinimogThemeScripts.productModel,
              "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            ],
            "product-model-assets"
          );
        }
      })
      .catch(console.error);
  }

  close(e) {
    if (this.modal && this.modal.modal) {
      this.modal.modal.classList.remove('product-quickview-modal');
    }
    this.modal.close(e);
    document.documentElement.classList.remove('prevent-scroll');
    this.isOpen = false
  }

  toggleLoading(target, loading) {
    if (loading) {
      target.classList.add("m-spinner-loading");
    } else {
      target.classList.remove("m-spinner-loading");
    }
  }
}

// Place the function outside the class
function hideSingleOptionVariantPicker(context) {
  (context || document).querySelectorAll('.main-product__block.main-product__block-variant_picker').forEach(function (block) {
    block.querySelectorAll('.m-product-option--content').forEach(function (optionContent) {
      if (optionContent.children.length === 1) {
        block.style.display = 'none';
      }
    });
  });
}

MinimogTheme.ProductQuickView = new QuickView();
